import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  TextField,
  Grid,
  FormControlLabel,
  Checkbox,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  GetAllCityOfState,
  GetAllStates,
} from "../../Common/API/Geography/action";
import { getLocationAndPincodeAction } from "../../../v2/Onboarding/auth/action";
import StandardChip from '../../../v2/MUI_custom_component/chips/StandardChip';


const STPDetails = ({
  firm = {},
  setBuyerDetails = () => {},
  influencerTabSelected = false,
  selectedRole
}) => {
  const dispatch = useDispatch();

  const {
    isDeliveryAddressSameAsConsigneeAddress,
  } = useSelector((state) => {
    return {
      isDeliveryAddressSameAsConsigneeAddress:
        state.bcmOrderReducer.isDeliveryAddressSameAsConsigneeAddress,
    };
  });

  const [buyer, setBuyer] = useState({
    ...firm,
    delivery_district_id: firm?.delivery_district_id
      ? firm?.delivery_district_id
      : firm?.district_id,
    delivery_Address_line1: firm?.delivery_Address_line1
      ? firm?.delivery_Address_line1
      : firm?.company_address1,
    delivery_Address_line2: firm?.delivery_Address_line2
      ? firm?.delivery_Address_line2
      : firm?.company_address2,
    delivery_Address_line3: firm?.delivery_Address_line3
      ? firm?.delivery_Address_line3
      : firm?.company_address3,
    delivery_company_pincode: firm?.delivery_company_pincode
      ? firm?.delivery_company_pincode
      : firm?.company_pincode,
    delivery_location_name: firm?.delivery_location_name
      ? firm?.delivery_location_name
      : firm?.location_name,
    delivery_location_id: firm?.delivery_location_id
      ? firm?.delivery_location_id
      : firm?.location_id,
  });
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [checked, setChecked] = useState(true);
  const [allPincodes, setAllPincodes] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [firstSelection, setFirstSelection] = useState(null);

  const getlocationPincode = async (
    districtId,
    locationId = null,
    PincodeId = null,
  ) => {
    if (PincodeId && buyer.delivery_location_id) return;
    if (locationId && buyer.delivery_company_pincode) return;
    const { data, error } = await getLocationAndPincodeAction(districtId, {
      location_id: locationId,
      pincode_id: PincodeId,
    });
    if (!error) {
      if (locationId && !buyer.delivery_company_pincode) {
        setAllPincodes(
          data.pincode_list.map((pincode) => ({
            label: pincode.pincode_name,
            value: pincode.pincode_id,
          })),
        );
      } else if (PincodeId && !buyer.delivery_location_id) {
        setAllCities(
          data.location_list.map((city) => ({
            label: city.location_name,
            value: city.location_id,
          })),
        );
      } else if (!locationId && !PincodeId) {
        setAllPincodes(
          data.pincode_list.map((pincode) => ({
            label: pincode.pincode_name,
            value: pincode.pincode_id,
          })),
        );
        setAllCities(
          data.location_list.map((city) => ({
            label: city.location_name,
            value: city.location_id,
          })),
        );
      }
    }
  };

  useEffect(() => {
    setBuyerDetails(buyer);
  }, [buyer]);

  const getStates = async () => {
    const { data, error, message } = await GetAllStates();

    if (!error) {
      setStates(
        data.map((state) => ({
          label: state.state_name,
          value: state.id,
        })),
      );
    } else {
      return toast.error(message);
    }
  };

  const getDistricts = async (stateId) => {
    setDistricts([]);

    const { data, error, message } = await GetAllCityOfState(stateId);

    if (!error) {
      setDistricts(
        data.map((district) => ({
          label: district.district_name,
          value: district.id,
        })),
      );
    } else return toast.error(message);
  };

  useEffect(() => {
    if (buyer.state_id) getDistricts(buyer.state_id);
  }, [buyer.state_id]);

  useEffect(() => {
    getStates();
  }, []);

  useEffect(() => {
      if (buyer?.delivery_district_id) {
        getlocationPincode(buyer.delivery_district_id);
      }
    }, [buyer.delivery_district_id]);

  const getStateName = (stateId) => {
    const state = states.find(s => s.value === stateId);
    return state ? state.label : stateId;
  };
  const getDistrictName = (districtId) => {
    const district = districts.find(d => d.value === districtId);
    return district ? district.label : districtId;
  };
  useEffect(() => {
    if (buyer.delivery_company_pincode) {
      getlocationPincode(
        buyer.delivery_district_id,
        null,
        buyer.delivery_company_pincode,
      );
    }
  }, [buyer.delivery_company_pincode]);

  useEffect(() => {
    if (buyer.delivery_location_id) {
      getlocationPincode(
        buyer.delivery_district_id,
        buyer.delivery_location_id,
        null,
      );
    }
  }, [buyer.delivery_location_id]);

  return (
    <Box>
      <Typography variant="h2" sx={{ mb: 2, fontWeight: 'bold' }}>
        Shipping Info
      </Typography>
      <Paper sx={{ padding: 3, borderRadius: 2, mb: 3 }}>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
            >
              
                <Typography variant="h2" sx={{ mb: 2, fontWeight: 'bold' }}>
                  Billing Info
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Box sx={{ background: '#fff', borderRadius: 2 }}>
                    <Box>
                      {buyer?.company_name && (
                        <Typography variant="body1" sx={{ mb: 1 }}>
                        {buyer.company_name}
                        </Typography> 
                      )}
                      {buyer?.company_phone_no && (
                        <Typography variant="body1" sx={{ mb: 1 }}>
                          {buyer.company_phone_no}
                        </Typography> 
                      )}
                      
                      { (buyer?.company_address1 || buyer.company_address2 || buyer.company_address3)  && (
                      <Typography variant="body1" sx={{ mb: 1 }}>
                          {buyer?.company_address1 || ''} {buyer?.company_address2 || ''} {buyer?.company_address3 || ''}
                      </Typography> 
                      )}
                      
                      {buyer?.district_id && (
                        <Typography variant="body1" sx={{ mb: 1 }}>
                          {getDistrictName(buyer.district_id)}
                        </Typography> 
                      )}
                      {buyer?.state_id && (
                        <Typography variant="body1" sx={{ mb: 1 }}>
                        {getStateName(buyer.state_id)}
                        </Typography> 
                      )}
                      {buyer.company_pincode && (
                        <Typography variant="body1" sx={{ mb: 1 }}>
                          {buyer.company_pincode}
                        </Typography> 
                      )}
                    </Box>
                  </Box>
                  <Box>
                  {selectedRole && (
                    <StandardChip label={selectedRole} selected={true} />
                  )}
                </Box>
              </Box>
          </Grid>
        </Grid>
      </Paper>
      <Paper
        sx={{
          padding: 3,
          borderRadius: 2,
          mb: 3,
          display: influencerTabSelected ? 'none' : 'block',
        }}
      >
        <Typography
          variant='h6'
          gutterBottom
        >
          Shipping Address
        </Typography>
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <FormControlLabel
              control={
                <Checkbox
                  name='useSameAsConsignee'
                  checked={isDeliveryAddressSameAsConsigneeAddress}
                  color='primary'
                  onClick={() => {
                    setChecked((prev) => !prev);
                    setBuyer((prev) => ({
                      ...prev,
                      delivery_Address_line1: buyer?.company_address1,
                      delivery_Address_line2: buyer?.company_address2,
                      delivery_Address_line3: buyer?.company_address3,
                      delivery_location_id: buyer?.location_id,
                      delivery_pricing_geography_id:
                        buyer?.pricing_geography_id,
                      delivery_district_id: buyer.district_id,
                      delivery_company_pincode: buyer.company_pincode,
                    }));
                    dispatch({
                      type: 'SET_DELIVERY_ADDRESS_SAME_AS_CONSIGNEE_ADDRESS',
                      data: !isDeliveryAddressSameAsConsigneeAddress,
                    });
                  }}
                />
              }
              label='Same As Billing Address'
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <TextField
              fullWidth
              label='Address line 1'
              variant='outlined'
              disabled={isDeliveryAddressSameAsConsigneeAddress}
              defaultValue={buyer.delivery_Address_line1}
              value={buyer.delivery_Address_line1}
              onChange={(e) =>
                setBuyer((prev) => ({
                  ...prev,
                  delivery_Address_line1: e.target.value,
                }))
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <TextField
              fullWidth
              label='Address line 2'
              variant='outlined'
              disabled={isDeliveryAddressSameAsConsigneeAddress}
              defaultValue={buyer.delivery_Address_line2}
              value={buyer.delivery_Address_line2}
              onChange={(e) =>
                setBuyer((prev) => ({
                  ...prev,
                  delivery_Address_line2: e.target.value,
                }))
              }
            />
          </Grid>
          <Grid
            item
            xs={12}
          >
            <TextField
              fullWidth
              label='Address line 3'
              variant='outlined'
              disabled={isDeliveryAddressSameAsConsigneeAddress}
              defaultValue={buyer.delivery_Address_line3}
              value={buyer.delivery_Address_line3}
              onChange={(e) =>
                setBuyer((prev) => ({
                  ...prev,
                  delivery_Address_line3: e.target.value,
                }))
              }
            />
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
          >
            <FormControl fullWidth>
              <InputLabel disabled>State</InputLabel>
              <Select
                value={buyer.state_id}
                label={'State'}
                disabled
                onChange={(e) => {
                  setBuyer((prev) => ({ ...prev, state_id: e.target.value }));
                }}
              >
                {states.map((state) => {
                  return <MenuItem value={state.value}>{state.label}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
          >
            <FormControl fullWidth>
              <InputLabel disabled={isDeliveryAddressSameAsConsigneeAddress}>
                District
              </InputLabel>
              <Select
                id='demo-simple-select-label'
                value={buyer.delivery_district_id || ''}
                label='District'
                disabled={isDeliveryAddressSameAsConsigneeAddress}
                onChange={(e) => {
                  const found = districts.find(
                    (d) => d.value === e.target.value,
                  );
                  setBuyer((prev) => ({
                    ...prev,
                    delivery_district_id: e.target.value,
                    delivery_district_name: found.label,
                    delivery_location_id: null,
                    delivery_location_name: null,
                    delivery_pricing_geography_id: null,
                    delivery_pricing_geography_name: null,
                    delivery_company_pincode: null,
                    delivery_Address_line1: '',
                    delivery_Address_line2: '',
                    delivery_Address_line3: '',
                  }));
                  setFirstSelection(null);
                }}
              >
                {districts.map((district) => {
                  return (
                    <MenuItem value={district.value}>{district.label}</MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
          >
            <FormControl fullWidth>
              <InputLabel disabled={isDeliveryAddressSameAsConsigneeAddress}>
                Location
              </InputLabel>
              <Select
                value={buyer?.delivery_location_id || ''}
                disabled={isDeliveryAddressSameAsConsigneeAddress}
                label='Location'
                onChange={(e) => {
                  const found = allCities.find(
                    (d) => d.value === e.target.value,
                  );
                  if (!firstSelection) setFirstSelection('city');
                  setBuyer((prev) => ({
                    ...prev,
                    delivery_location_id: e.target.value,
                    delivery_location_name: found.label,
                    ...(firstSelection === 'city'
                      ? { delivery_company_pincode: null }
                      : {}),
                  }));
                }}
              >
                {allCities.map((location) => {
                  return (
                    <MenuItem value={location.value}>{location.label}</MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={4}
          >
            <FormControl fullWidth>
              <InputLabel disabled={isDeliveryAddressSameAsConsigneeAddress}>
                Pincode
              </InputLabel>
              <Select
                value={buyer.delivery_company_pincode}
                label={'Pincode'}
                disabled={isDeliveryAddressSameAsConsigneeAddress}
                onChange={(e) => {
                  if (!firstSelection) setFirstSelection('pincode');
                  setBuyer((prev) => ({
                    ...prev,
                    delivery_company_pincode: e.target.value,
                    ...(firstSelection === 'pincode'
                      ? {
                          delivery_location_id: null,
                          delivery_location_name: '',
                        }
                      : {}),
                  }));
                }}
              >
                {allPincodes.map((pincode) => {
                  return (
                    <MenuItem value={pincode.value}>{pincode.label}</MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};
export default STPDetails;
